import {useEffect,useRef,useState} from "react";
export function normalizedRms(samples){
 if(!samples?.length)return 0;let energy=0;
 for(const sample of samples){const value=(sample-128)/128;energy+=value*value}
 return Math.max(0,Math.min(1,(Math.sqrt(energy/samples.length)-.008)*7));
}
export function useVoiceMeter(active,enabled=true){
 const level=useRef(0),[status,setStatus]=useState("off");
 useEffect(()=>{
  level.current=0;
  if(!active||!enabled){setStatus("off");return;}
  const Context=window.AudioContext||window.webkitAudioContext;
  if(!Context||!navigator.mediaDevices?.getUserMedia){setStatus("unavailable");return;}
  let disposed=false,stream,context,source,frame=0,last=0;
  setStatus("starting");
  const startTimer=setTimeout(()=>{if(!disposed){disposed=true;release();setStatus("unavailable")}},5000);
  const visibility=()=>{if(document.hidden)release()};
  function release(){
   cancelAnimationFrame(frame);level.current=0;source?.disconnect();
   stream?.getTracks().forEach(track=>track.stop());
   if(context&&context.state!=="closed")context.close().catch(()=>{});
  }
  (async()=>{
   try{
    stream=await navigator.mediaDevices.getUserMedia({audio:{echoCancellation:true,noiseSuppression:true,autoGainControl:true},video:false});
    if(disposed||document.hidden){release();return;}
    context=new Context();await context.resume();
    if(disposed||document.hidden){release();return;}
    const analyser=context.createAnalyser();analyser.fftSize=256;analyser.smoothingTimeConstant=.7;
    source=context.createMediaStreamSource(stream);source.connect(analyser);
    // Never connect to context.destination: no mic monitoring, recording or upload.
    const samples=new Uint8Array(analyser.fftSize);clearTimeout(startTimer);setStatus("live");
    const draw=at=>{
     if(disposed||document.hidden)return;
     if(at-last>=33){analyser.getByteTimeDomainData(samples);const rms=normalizedRms(samples);level.current+=(rms-level.current)*(rms>level.current?.55:.2);last=at}
     frame=requestAnimationFrame(draw);
    };
    frame=requestAnimationFrame(draw);
   }catch(e){clearTimeout(startTimer);release();if(!disposed)setStatus("unavailable")}
  })();
  document.addEventListener("visibilitychange",visibility);
  return()=>{disposed=true;clearTimeout(startTimer);release();document.removeEventListener("visibilitychange",visibility)};
 },[active,enabled]);
 return {level,status};
}
